import React from "react";

/**
 * Reusable Card component with multiple variants
 */
const Card = ({
  children,
  className = "",
  glass = false,
  hover = false,
  ...props
}) => {
  const base = glass ? "glass rounded-2xl" : "card";

  const hoverStyle = hover
    ? "hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer"
    : "";

  return (
    <div className={`${base} ${hoverStyle} ${className}`} {...props}>
      {children}
    </div>
  );
};

export const StatCard = ({
  label,
  value,
  change,
  up,
  icon: Icon,
  color = "primary",
}) => {
  const colorMap = {
    primary: "text-primary-500 bg-primary-100 dark:bg-primary-900/30",
    accent: "text-accent-500 bg-cyan-100 dark:bg-cyan-900/30",
    green: "text-emerald-500 bg-emerald-100 dark:bg-emerald-900/30",
    red: "text-red-500 bg-red-100 dark:bg-red-900/30",
  };

  return (
    <Card className="p-6">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-1">
            {label}
          </p>
          <p className="text-2xl font-bold font-display text-gray-900 dark:text-white">
            {value}
          </p>
          {change && (
            <p
              className={`text-xs mt-1 font-medium ${up ? "text-emerald-500" : "text-red-500"}`}
            >
              {up ? "↑" : "↓"} {change} vs last month
            </p>
          )}
        </div>
        {Icon && (
          <div
            className={`p-2.5 rounded-xl ${colorMap[color] || colorMap.primary}`}
          >
            <Icon size={20} />
          </div>
        )}
      </div>
    </Card>
  );
};

export default Card;
